import translator from '../translate';

export function getTranslateElement(str) {
  if (typeof str !== 'string' || !translator) {
    return str;
  }

  return str.substring(0, 4) === 'msg_' ? translator.getMessage(str) : str;
}
